import {ChangeDetectionStrategy, Component, Signal} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {MemberSalesData} from '../../identity/member-sales-search.model';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {ReceiptComponent} from "../receipt/receipt.component";

@Component({
    selector: "woa-sale-receipt-page",
    templateUrl: "./sale-receipt-page.component.html",
    styleUrl: "./sale-receipt-page.component.scss",
    providers: [{provide: Page, useExisting: SaleReceiptPageComponent}],
    imports: [
        ModalPageLayoutComponent,
        ReceiptComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaleReceiptPageComponent extends Page {
    public readonly sale: Signal<MemberSalesData> = navParam.required<MemberSalesData>("sale");
}
